import React from "react";
import { useLang } from "@/lib/LanguageContext";
import { Mail, MessageCircle, HelpCircle } from "lucide-react";

export default function Help() {
  const { t } = useLang();
  return (
    <div className="min-h-screen max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="help-page">
      <h1 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-white mb-8">
        {t("helpTitle")}
      </h1>
      <div className="space-y-6">
        <div className="bg-[#1C1917] border border-white/5 rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <Mail className="w-5 h-5 text-amber-500" />
            <h2 className="text-lg font-medium text-white">Nous contacter</h2>
          </div>
          <p className="text-sm text-stone-400 mb-3">
            {"Pour toute question ou assistance, envoyez-nous un e-mail :"}
          </p>
          <a href="mailto:support@k2what-to-cook.com" className="text-amber-500 hover:text-amber-400 text-sm font-medium">
            support@k2what-to-cook.com
          </a>
        </div>
        <div className="bg-[#1C1917] border border-white/5 rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <HelpCircle className="w-5 h-5 text-amber-500" />
            <h2 className="text-lg font-medium text-white">{"Questions fr\u00e9quentes"}</h2>
          </div>
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium text-white mb-1">{"Comment g\u00e9n\u00e9rer une recette ?"}</h3>
              <p className="text-sm text-stone-400">
                {"Connectez-vous, allez dans la section \u00ab Cuisiner \u00bb, s\u00e9lectionnez vos ingr\u00e9dients disponibles et cliquez sur \u00ab G\u00e9n\u00e9rer la recette \u00bb. L'IA cr\u00e9era une recette personnalis\u00e9e en quelques secondes."}
              </p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-white mb-1">{"Combien de recettes puis-je g\u00e9n\u00e9rer gratuitement ?"}</h3>
              <p className="text-sm text-stone-400">
                {"Le plan gratuit vous permet de g\u00e9n\u00e9rer 1 recette. Pour des recettes illimit\u00e9es, souscrivez \u00e0 l'abonnement Premium."}
              </p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-white mb-1">{"Comment sauvegarder une recette ?"}</h3>
              <p className="text-sm text-stone-400">
                {"Apr\u00e8s avoir g\u00e9n\u00e9r\u00e9 une recette, cliquez sur l'ic\u00f4ne c\u0153ur pour l'ajouter \u00e0 vos favoris. Retrouvez toutes vos recettes sauvegard\u00e9es dans la section \u00ab Favoris \u00bb."}
              </p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-white mb-1">{"Comment annuler mon abonnement ?"}</h3>
              <p className="text-sm text-stone-400">
                {"Vous pouvez annuler votre abonnement \u00e0 tout moment depuis votre profil ou en nous contactant par e-mail. Votre acc\u00e8s Premium restera actif jusqu'\u00e0 la fin de la p\u00e9riode pay\u00e9e."}
              </p>
            </div>
            <div>
              <h3 className="text-sm font-medium text-white mb-1">{"Les recettes sont-elles fiables ?"}</h3>
              <p className="text-sm text-stone-400">
                {"Les recettes sont g\u00e9n\u00e9r\u00e9es par intelligence artificielle et sont \u00e0 titre indicatif. Nous vous recommandons de v\u00e9rifier les ingr\u00e9dients en cas d'allergies et d'adapter les recettes \u00e0 vos go\u00fbts."}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-[#1C1917] border border-white/5 rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <MessageCircle className="w-5 h-5 text-amber-500" />
            <h2 className="text-lg font-medium text-white">{"Suggestions et retours"}</h2>
          </div>
          <p className="text-sm text-stone-400">
            {"Votre avis nous int\u00e9resse ! N'h\u00e9sitez pas \u00e0 nous faire part de vos suggestions d'am\u00e9lioration ou de nouvelles fonctionnalit\u00e9s que vous aimeriez voir dans What To Cook."}
          </p>
        </div>
      </div>
    </div>
  );
}
